import { render } from "./WrenchIcon.vue?vue&type=template&id=3e9a2645"
import script from "./WrenchIcon.vue?vue&type=script&lang=js"
export * from "./WrenchIcon.vue?vue&type=script&lang=js"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__